// * GET =====================================
export const WIDGET_GET_WIDGET_BY_ID = (widgetId: string) =>
  `/widget/widget_by_id?widgetId=${widgetId}`;

export const WIDGET_GET_DEFAULT_OUTPUT_FORMATS_SETTINGS =
  '/widget/default_output_formats_settings';

export const WIDGET_GET_CHART_TYPES = `/widget/chart_types`;

export const WIDGET_GET_GET_OBJECT_WIDGETS = `/widget/get_object_widgets`;

export const WIDGET_GET_GET_DEFAULT_STRUCTURE = `/widget/get_default_structure`;
// * PATCH ===================================
export const WIDGET_PATCH_UPDATE = (widgetId: string) =>
  `/widget/${widgetId}/update`;

export const WIDGET_PATCH_UPDATE_WIDGETS_ORDER = `/widget/update_widgets_order`;

// * POST ====================================
export const WIDGET_POST_PREVIEW = `/widget/preview`;

export const WIDGET_POST_CREATE = `/widget/create`;

export const WIDGET_POST_WIDGET_DATA = (widgetId: string) =>
  `/widget/${widgetId}/widget_data`;

export const WIDGET_POST_SWAP_TYPE = (widgetId: string) =>
  `/widget/${widgetId}/swap_type`;

export const WIDGET_POST_MASS_UPDATE = `/widget/mass_update`;

export const WIDGET_POST_MASS_OPERATION = `/widget/mass_operation`;

export const WIDGET_POST_EXPORT = (widgetId: string) =>
  `/widget/${widgetId}/export`;

// * DELETE ==================================
export const WIDGET_DELETE_DELETE = (widgetId: string) =>
  `/widget/${widgetId}/delete`;

export const WIDGET_DELETE_MASS_DELETE = `/widget/mass_delete`;

// * PUT =====================================
